export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/index.js
// module id = 1255
// module chunks = 4